import React from 'react';
import type { Permission } from '../../data/models/permission.model';

export const useHasPermission = (
  user: any,
  permission: Permission,
): boolean => {
  const [hasPermission, setHasPermission] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (user?.access?.permissions) {
      const hasIt = !!user.access.permissions.find(
        (p: Permission) =>
          p.resource === permission.resource &&
          p.action === permission.action &&
          p.scope === permission.scope,
      );
      setHasPermission(hasIt);
    }
  }, [user, permission]);

  return hasPermission;
};
